console.log('[CustomAction] Script loaded');

function initCustomActionButtons() {
  console.log('[CustomAction] initCustomActionButtons() fired');

  const roots = document.querySelectorAll('[data-custom-action]');
  console.log(`[CustomAction] Found ${roots.length} button root(s)`);

  roots.forEach(root => {
    const link = root.querySelector('[data-editor-link]');
    if (!link) {
      console.warn('[CustomAction] No link found inside custom-action');
      return;
    }

    const baseUrl = root.dataset.baseUrl || '';
    console.log(`[CustomAction] Base URL: ${baseUrl}`);

    function updateLink(variantId) {
      if (!variantId) {
        console.warn('[CustomAction] updateLink() called with no variantId');
        return;
      }
      const newHref = `${baseUrl}?variant=${variantId}`;
      link.href = newHref;
      console.log(`[CustomAction] Updated link href → ${newHref}`);
    }

    // 1️⃣ Try to detect current variant from URL or input (for first load)
    function getInitialVariant() {
      const urlParams = new URLSearchParams(window.location.search);
      const fromUrl = urlParams.get('variant');
      if (fromUrl) {
        console.log(`[CustomAction] Found variant in URL → ${fromUrl}`);
        return fromUrl;
      }

      const input = document.querySelector('input[name="id"]');
      const fromInput = input?.value;
      if (fromInput) {
        console.log(`[CustomAction] Found variant in input → ${fromInput}`);
        return fromInput;
      }

      console.warn('[CustomAction] No variant found on initial load');
      return null;
    }

    // 2️⃣ Initialize link with default or URL variant
    const initialVariant = getInitialVariant();
    if (initialVariant) updateLink(initialVariant);

    // 3️⃣ Listen for custom picker variant change
    document.addEventListener('variant:changed', (e) => {
      const id = e.detail?.variant?.id;
      console.log('[CustomAction] variant:changed event fired →', id);
      if (id) updateLink(id);
    });

    // 4️⃣ Handle click → open editor
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const href = link.getAttribute('href');
      console.log(`[CustomAction] Button clicked → href: ${href}`);
      if (href && href !== '#') {
        console.log(`[CustomAction] Opening → ${href}`);
        window.open(href, '_blank');
      } else {
        console.warn('[CustomAction] href empty or #, not opening anything');
      }
    });
  });
}

// Run on initial load
document.addEventListener('DOMContentLoaded', () => {
  console.log('[CustomAction] DOMContentLoaded');
  initCustomActionButtons();
});

// Run again when Shopify dynamically reloads sections in the editor
document.addEventListener('shopify:section:load', (e) => {
  console.log('[CustomAction] shopify:section:load fired →', e.detail);
  initCustomActionButtons();
});
